import { render, staticRenderFns } from "./categoryBox.vue?vue&type=template&id=4142dde0&scoped=true&"
import script from "./categoryBox.vue?vue&type=script&lang=js&"
export * from "./categoryBox.vue?vue&type=script&lang=js&"
import style0 from "./categoryBox.vue?vue&type=style&index=0&id=4142dde0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142dde0",
  null
  
)

export default component.exports